import { Injectable } from '@angular/core';
import { DecodedToken } from '@com-delta-idp/mnx-oauth';
import { jwtDecode } from 'jwt-decode';
import { loginAndGetDashboardResponse } from '../login-modal/models/login-authentication-screen.interface';

@Injectable({
  providedIn: 'root'
})
export class CoreUtilHelperService {
  setLocalStorageWithExpiry(key: string, value: string | boolean, ttl: number) {
    const now = new Date();
    const item = { value: value, expiry: now.getTime() + ttl };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getLocalStorageWithExpiry(key: string) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  checkEnrollmentDate(emailAddressLocalDate: string): boolean {
    const today = new Date().toLocaleDateString('en-CA');
    const enrollDate = Date.parse(emailAddressLocalDate);
    const currentDate = Date.parse(today);
    return enrollDate + 86400000 < currentDate;
  }

  checkMfaFlow(decoded: DecodedToken, emailAddressLocalDate: string): boolean {
    return decoded.mdc == 0 && this.checkEnrollmentDate(emailAddressLocalDate);
  }

  redirectToMfa(
    response?: loginAndGetDashboardResponse,
    access_token?: string
  ): boolean {
    if (access_token) {
      const decoded: DecodedToken = jwtDecode(access_token);
      if (
        response?.emailAddressLocalDate &&
        this.checkMfaFlow(decoded, response.emailAddressLocalDate)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
